import React from "react";

import logo from "@src/assets/images/acoucou-signet.svg?url";
import { messages } from "./Footer.messages";

import styles from "./Footer.module.scss";
import { useIntl } from "react-intl";

interface FooterProps {}

export const Footer: React.FC<FooterProps> = () => {
  const { formatMessage } = useIntl();

  return (
    <div className={styles.root}>
      <div className={styles.logoWrapper}>
        <img src={logo} alt="Acoucou" />
      </div>
      <div className={styles.text} dangerouslySetInnerHTML={{ __html: formatMessage(messages.text) }} />
    </div>
  );
};
